import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'calculator.button.label': {
    id: 'calculator.button.label',
    defaultMessage: 'Calculator',
    description: 'Button label to expand or close the calculator',
  },
  'calculator.input.field.label': {
    id: 'calculator.input.field.label',
    defaultMessage: 'Calculator Input',
    description: 'label for calculator input',
  },
  'calculator.submit.button.label': {
    id: 'calculator.submit.button.label',
    defaultMessage: 'Calculate',
    description: 'Submit button label to execute the calculator',
  },
  'calculator.result.field.label': {
    id: 'calculator.result.field.label',
    defaultMessage: 'Calculator Result',
    description: 'label for calculator result',
  },
  'calculator.result.field.placeholder': {
    id: 'calculator.result.field.placeholder',
    defaultMessage: 'Result',
    description: 'placeholder for calculator result',
  },
});

export default messages;
